import React, { useEffect, useState } from "react";

import { Container } from "./styles";

type IProps = {
  value?: any;
  onClick?: any;
  isDisabled?: boolean;
};

const Switch: React.FC<IProps> = ({
  value,
  onClick,
  isDisabled = false,
}: IProps) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    function loadComponent(): void {
      if (value) setIsActive(value);
    }

    loadComponent();
  }, [value]);

  const handleClick = (): void => {
    if (isDisabled) return;
    setIsActive((state) => !state);
    if (!onClick) return;
    onClick();
  };

  return (
    <Container
      isActive={isActive}
      isDisabled={isDisabled}
      onClick={handleClick}
    >
      <div />
    </Container>
  );
};

Switch.defaultProps = {
  value: false,
  onClick: null,
  isDisabled: false,
};

export default Switch;
